import PropTypes from 'prop-types';
import React from 'react';

const Footer = (props) => (
	<footer
		className={`bsknacht17-page-footer js-bsknacht17-state--${props.view}`}
	>
		<p className="bsknacht17-page-footer__left">
			<a href="https://www.braunschweig.de/kulturnacht/">
				<span>Weitere Infos zur Kulturnacht</span>
			</a>
		</p>
		<p className="bsknacht17-page-footer__right">
			<a href="https://www.instagram.com/kulturnacht.bs/">
				<span>@kulturnacht.bs auf Instagram</span>
			</a>
		</p>

		<p className="bsknacht17-page-footer__small-print">
			<a href="https://www.braunschweig.de/impressum.html" rel="external">
				<span>Impressum und Bildnachweis</span>
			</a>
			, Karte: © Stadt Braunschweig und{' '}
			<a href="https://www.openstreetmap.org/" rel="external">
				<span>OpenStreetMap</span>
			</a>{' '}
			(
			<a href="https://opendatacommons.org/licenses/odbl/" rel="external">
				<span>Open Database License</span>
			</a>
			)
			{/* <br />
			Konzept & Umsetzung:{' '}
			<a href="https://neonaut.de/">
				<span>Neonaut GmbH</span>
			</a> */}
		</p>
	</footer>
);

Footer.propTypes = {
	view: PropTypes.string.isRequired,
};

export default Footer;
